import { ActionButtonProps, Box, Button, ColorOptions, Form, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import * as React from 'react'
import { FC, useCallback, useEffect, useState } from 'react'
import { loginStrings } from '../../../data/static/strings'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { useIsMobile } from '../../../util/useFontSize'
import {
  clearSession,
  Colors,
  getFromStore,
  getSelectedDate,
  isSessionValid,
  storeData,
  testProps,
  useWindowDimensions,
} from '../../../util/util'
import { ResendOtp } from '../../Otp/ResendOtp'
import { getEmailLoginFormData, loginForm } from '../FormData'
import { styles } from '../styles'
import ShowHidePassword from './ShowHidePassword'

interface LoginCardProps {
  hide?: boolean
  getMobileNumber: (mobNumber: string) => void
  deeplinkPath: string
}

const renderSubmitButtons = (
  { values, isCurrentFormValid, title }: any,
  getMobileNumber: any,
  verifyCredentials: any,
  themedStyle: any,
  state: any,
  // isRememberMobile: boolean,
  updateMobile: any,
  setPassword: any,
  searchMerchantHandler: any,
): React.ReactElement => {
  const handleLoginPress = (): void => {
    if (values.mobileNumber && values.password && isCurrentFormValid) {
      setPassword(values.password)
      verifyCredentials(values.mobileNumber, values.password)
      updateMobile(values.mobileNumber)
      storeData(loginStrings.userMobileNumber, values.mobileNumber)
      getMobileNumber(values.mobileNumber)
    }
  }
  const isLoading = searchMerchantHandler?.state === 'pending' || state === 'pending'
  return (
    <Box {...themedStyle.loginBtnContainerStyle}>
      <Button
        isFull
        disabled={!isCurrentFormValid || isLoading}
        {...testProps('login-button')}
        type={'primary'}
        color={'BLUE'}
        underlayColor={Colors.BG_BLUE_LIGHT as ColorOptions}
        onPress={handleLoginPress}>
        <Text hide={isLoading} color={'WHITE'} fontWeight={'bold'}>
          {title}
        </Text>
        {isLoading && <Loader color={'WHITE'} />}
      </Button>
    </Box>
  )
}

const getInitValues = (mNumber: string, emailId: string, password: string): any => {
  return {
    mobileNumber: mNumber && mNumber.length > 0 && mNumber.length <= 10 ? mNumber : '',
    password: password,
    email: emailId,
  }
}

const LoginCard: FC<LoginCardProps> = ({ hide, getMobileNumber, deeplinkPath }: LoginCardProps) => {
  const {
    sessionData,
    verifyCredentials,
    sendOtpAync,
    mobileNumber,
    updateMobile,
    updateDatesInAllScreens,
    getAllMerchantMetaData,
    returnJfsUserIdAfterLogin,
    merchantData,
    validateOtpAync,
    isEmailLogin,
    setIsEmailLogin,
    storedEmailId,
  } = useStores((root) => ({
    sessionData: root.user.session,
    verifyCredentials: root.user.session.verifyCredentials,
    sendOtpAync: root.user.session.sendOtpAync,
    mobileNumber: root.settings.metaData.mobileNumber,
    updateMobile: root.settings.metaData.updateMobileNumber,
    updateDatesInAllScreens: root.updateDatesInAllScreens,
    getAllMerchantMetaData: root?.user?.getAllMerchantMetaData,
    returnJfsUserIdAfterLogin: root.user.session.returnJfsUserIdAfterLogin,
    merchantData: root.user.merchantData(),
    validateOtpAync: root.user.session.validateOtpAync,
    isEmailLogin: root.user.session.isEmailLogin,
    setIsEmailLogin: root.user.session.setIsEmailLogin,
    storedEmailId: root.user.session.emailId,
  }))

  const [login, { state, data }] = useLazyApiData(verifyCredentials)
  const [lazySendOtp, sendOtpHandler] = useLazyApiData(sendOtpAync)
  const [lazyValidateOtp, validateOtpHandler] = useLazyApiData(validateOtpAync)
  const [searchAllMerchants, searchMerchantHandler] = useLazyApiData(getAllMerchantMetaData)

  const navigation = useNavigation()
  const [hidePassword, setHidePassword] = useState(false)
  const [password, setPassword] = useState('')
  const [isChecked, onChecked] = useState(false)
  // const [isEmailLogin, setIsEmailLogin] = useState(false)
  const [currentStep, setCurrentStep] = useState(0)

  const viewPortWidth = useWindowDimensions()
  const formRef = React.useRef(null)

  useEffect(() => {
    try {
      getFromStore(loginStrings.isRemembered).then((value) => {
        if (value !== null && value !== undefined && value !== '') {
          const jsonValue = JSON.parse(value)
          if (jsonValue) {
            onChecked(jsonValue)
            return
          }
        }
      })
    } catch (error) {
      console.log(error)
      throw new Error('Exception Occured!')
    }
  }, [])

  useEffect(() => {
    if (sendOtpHandler?.state === 'fulfilled') {
      setCurrentStep(1)
    }
  }, [sendOtpHandler?.state])

  const isMobile = useIsMobile()
  const updateSelectedDateToCurrentDate = useCallback(() => {
    const updatedDateObj = {
      fromDate: getSelectedDate(1),
      toDate: new Date(Date.now()),
      position: {
        top: 0,
        left: 0,
        visible: false,
      },
      dateLabel: 'Today',
    }
    updateDatesInAllScreens(updatedDateObj, isMobile)
  }, [updateDatesInAllScreens])

  useEffect(() => {
    if (searchMerchantHandler?.state === 'fulfilled' && merchantData?.length > 0) {
      console.log('searchMerchantHandler', searchMerchantHandler)
      const paths: any = {
        'initiate-refunds': Routes.RECENTS,
        'transactions/initiate-refunds': Routes.TRANSACTIONS,
        'transactions-details': Routes.TRANSACTIONS,
        'bulkrefund/report': Routes.BULK_REFUND,
        'bulkrefund/summary': Routes.BULK_REFUND,
        'refunds/initiate-refunds': Routes.REFUNDS,
        'subscriptions/initiate-refunds': Routes.SUBSCRIPTIONS,
        'refund-reports': Routes.REFUNDS,
        'bulk-refund': Routes.BULK_REFUND,
        'payment-links': Routes.PAYMENT_LINKS,
        payoutsbeneficiary: Routes.PAYOUTS_BENEFICIARY,
      }
      const mDeeplinkedPath = deeplinkPath !== 'login' ? paths[deeplinkPath] || deeplinkPath : Routes.RECENTS
      navigation.reset({
        index: 0,
        routes: [{ name: Routes.ROOTSCREEN, params: { path: mDeeplinkedPath } }],
      })
      updateSelectedDateToCurrentDate()
    } else if (
      (searchMerchantHandler?.state === 'fulfilled' && merchantData?.length < 1) ||
      searchMerchantHandler?.state === 'rejected'
    ) {
      clearSession()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantData.length, searchMerchantHandler?.state])

  useEffect(() => {
    if (state === 'fulfilled' && typeof data !== 'undefined') {
      if (isSessionValid(sessionData)) {
        const validJfsUserId = returnJfsUserIdAfterLogin()
        if (validJfsUserId?.length > 2) {
          searchAllMerchants(validJfsUserId)
        }
      }
    }
  }, [data, returnJfsUserIdAfterLogin, searchAllMerchants, sessionData, state])

  useEffect(() => {
    if (validateOtpHandler?.state === 'fulfilled') {
      if (isSessionValid(sessionData)) {
        const validJfsUserId = returnJfsUserIdAfterLogin()
        if (validJfsUserId?.length > 2) {
          searchAllMerchants(validJfsUserId)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOtpHandler?.state])
  if (hide) {
    return null
  }

  const isPasswordVisible = (isVisible: boolean): void => {
    setHidePassword(isVisible)
  }

  const handleLoginPress = (): void => {
    if (!isEmailLogin) {
      const pwd = formRef?.current?.getValues()?.password
      const mob = formRef?.current?.getValues()?.mobileNumber
      setPassword(pwd)
      login(mob, pwd)
      updateMobile(mob)
      storeData(loginStrings.userMobileNumber, mob)
      getMobileNumber(mob)
    } else if (isEmailLogin && currentStep === 0) {
      lazySendOtp(formRef?.current?.getValues()?.email)
    } else if (isEmailLogin && currentStep === 1) {
      lazyValidateOtp(formRef?.current?.getValues()?.email, formRef?.current?.getValues()?.otp)
    }
  }

  const renderActionButtons = (props: ActionButtonProps): React.ReactElement => {
    const isLoading = [state, sendOtpHandler?.state, validateOtpHandler?.state, searchMerchantHandler?.state].includes(
      'pending',
    )
    return (
      <Box {...themedStyle.loginBtnContainerStyle}>
        <Button
          isFull
          disabled={!props?.isCurrentFormValid || isLoading}
          {...testProps('login-button')}
          type={'primary'}
          color={'BLUE'}
          underlayColor={Colors.BG_BLUE_LIGHT as ColorOptions}
          onPress={handleLoginPress}>
          <Text hide={isLoading} color={'WHITE'} fontWeight={'bold'}>
            {props?.title}
          </Text>
          {isLoading && <Loader color={'WHITE'} />}
        </Button>
        <ModBox show={isEmailLogin && currentStep === 1}>
          <ResendOtp count={30} email={props?.values?.email} color="BLUE" type="EMAIL_OTP" />
        </ModBox>
      </Box>
    )
  }

  const getEnteredMobileNumber = (): string => {
    return isChecked ? mobileNumber : ''
  }
  const onChangeLoginModePress = () => setIsEmailLogin(!isEmailLogin)
  const onChangeEmailIdPress = () => setCurrentStep(0)

  const getFormData = (): any[] => {
    const mobileLoginFormData = [
      ...loginForm(
        getEnteredMobileNumber(),
        <ShowHidePassword
          isDisabled={state === 'pending'}
          isPasswordVisible={isPasswordVisible}
          showPassword={hidePassword}
        />,
        hidePassword,
        state === 'pending',
        onChecked,
        isChecked,
      ),
    ]
    return isEmailLogin ? getEmailLoginFormData({ onChangeEmailIdPress }) : mobileLoginFormData
  }

  const themedStyle = styles(viewPortWidth)
  const formData = getFormData()
  return (
    <Box {...themedStyle.loginFormCard} minWidth={viewPortWidth > 432 ? 320 : viewPortWidth - 36}>
      <Text {...themedStyle.loginTitleStyle}>{loginStrings.login}</Text>
      <Spacer size={24} />
      <Form
        ref={formRef}
        initialValues={getInitValues(mobileNumber, storedEmailId, password)}
        formData={formData}
        container={FormContainer}
        actionButtons={renderActionButtons}
        initialStep={formData?.[currentStep]?.key}
      />
      <ModBox
        mt={8}
        paddingBottom={4}
        alignItems={'center'}
        show={currentStep === 0}
        onPress={onChangeLoginModePress}
        underlayColor={'TRANSPARENT'}>
        <Text color={'BLUE'} fontFamily="jioType-medium">
          {`Login Using ${isEmailLogin ? 'Mobile No.' : 'Email'}`}
        </Text>
      </ModBox>
    </Box>
  )
}
export default LoginCard

export const FormContainer = ({ children }) => <Box w={'100%'}>{children}</Box>
